<template>
  <el-dialog
    :visible.sync="disableDialog"
    class="dialog-address"
    width="980px"
    title="货架调拨"
    @close="onClose"
  >
    <el-dialog width="70%" title="添加产品" :visible.sync="innerVisible" append-to-body>
      <!--------------------------------------- 下拉框 内层dialog------------------------------------->
      <el-table
        border
        ref="tableRef"
        tooltip-effect="dark"
        :data="productList"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        height="470px"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="品牌" show-overflow-tooltip prop="brandName"></el-table-column>
        <el-table-column label="系列" show-overflow-tooltip prop="seriesName"></el-table-column>
        <el-table-column label="产品名称" show-overflow-tooltip prop="proName"></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip prop="proModel"></el-table-column>
        <el-table-column label="订货号" show-overflow-tooltip prop="proOrdernum"></el-table-column>
        <el-table-column label="入库批次" show-overflow-tooltip>
          <template slot-scope="scope"><div class="line-limit-length">{{scope.row.batchNumber}}</div></template>
        </el-table-column>
        <el-table-column label="实际数量">
          <template slot-scope="scope">{{scope.row.counts}}</template>
        </el-table-column>
        <el-table-column label="锁定数量">
          <template slot-scope="scope">{{scope.row.lockCount}}</template>
        </el-table-column>
        <el-table-column label="可调拨数量" width="110">
          <template slot-scope="scope">{{scope.row.count}}</template>
        </el-table-column>
        <el-table-column label="调拨数量" width="155">
          <template slot-scope="scope">
            <el-input-number
              width="80%"
              @input.native="onInput"
              :precision="0"
              v-model="scope.row.number"
              controls-position="right"
              :min="1"
              :max="scope.row.count"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-right" v-if="type===0">
        <el-button @click="onSureProduct" type="primary">确认</el-button>
        <el-button @click="cancleSelect">取消</el-button>
      </span>
    </el-dialog>
    <!--------------------------------------- 下拉框 外层dialog------------------------------------->
    <el-form label-width="70px" :model="queryParams">
      <el-row :gutter="20" style="height:20px;">
        <el-col :span="6" style="padding-left:0px !important">
          <el-form-item label="仓库：">
            <div v-if="type===1">{{queryParams.storageName}}</div>
            <el-select
              :disabled="storageNameDisable"
              v-else
              v-model="queryParams.id"
              @change="onSelect(queryParams.id)"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in stockSelect"
                :key="index"
                :label="item.storageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调出货架：">
            <div v-if="type===1">{{queryParams.fromShelvesName}}</div>
            <el-select
              v-else
              v-model="queryParams.ssId"
              :disabled="storageNameDisable"
              @change="chagefromShelves"
            >
              <el-option
                v-for="(item,index) in shelfSelect"
                :key="index"
                :label="item.shelvesName"
                :value="item.ssId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调入货架：">
            <div v-if="type===1">{{queryParams.targetShelvesName}}</div>
            <el-select v-else v-model="queryParams.shelvesName">
              <el-option
                v-for="(item,index) in holdShelfSelect"
                :key="index"
                :label="item.shelvesName"
                :value="item.shelvesName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="type===1" style="text-align:right;">
          <el-button @click="exportWarehousing">导出</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="item-box-add">
      <!----------------------- 设置期初库存数据存储列表 外层dialog--------------------->
      <el-table
        class="tableHeight"
        border
        ref="tableRef"
        tooltip-effect="dark"
        :data="list"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <template slot="empty">
          <no-data style="padding:140px 0;">暂无数据</no-data>
        </template>
        <el-table-column label="品牌" width="80px" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.brandName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="系列" width="100px" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.seriesName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="产品名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.proName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.proModel}}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.proOrdernum}}</div>
          </template>
        </el-table-column>
        <el-table-column label="入库批次" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.batchNumber}}</div>
          </template>
        </el-table-column>
        <el-table-column label="调拨数量" v-if="type===0">
          <template slot-scope="scope">
            <el-input-number
              style="width:90px"
              @input.native="onInput"
              :precision="0"
              v-model="scope.row.number"
              controls-position="right"
              :min="1"
              :max="scope.row.count"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="调拨数量" v-if="type===1">
          <template slot-scope="scope">
            <div>{{ scope.row.count }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="type===0">
          <template slot-scope="scope">
            <span
              class="approval line-limit-length"
              @click="toDelete(scope.row)"
              style="color:#D35E5E;"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span v-if="type===0" class="add_product_btn">
      <div @click="onAddProduct()">
        <i class="el-icon-plus"></i>
        添加产品
      </div>
    </span>
    <span slot="footer" class="dialog-right" v-show="type ===0">
      <el-button @click="onSubmit" type="primary">保存</el-button>
      <el-button @click="cancle">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { queryBySbIdSsId, queryShelvesProducts, getStockProduct, addAllocation, querySsIdBySbIdAndSsId } from '@/api/storage/storage'
import noData from '@/components/module/noData'
import { downLoadFileBlob } from '@/util/tool'
import { addAllocationCoeDerive } from '@/api/purchase/purchaseManage'
export default {
  components: {
    noData
  },
  data () {
    return {
      storageNameDisable: false,
      disableDialog: false, // 外层dialog
      innerVisible: false, // 内层dialog
      loadingTable: false, // 列表loading
      stockSelect: [], // 仓库列表
      shelfSelect: [], // 货架列表
      holdShelfSelect: [], // 调入货架
      queryParams: {
        // 查询货架信息传参数
        id: '', // 仓库id
        ssId: '', // 调出货架id
        sssId: '', // 调入货架id
        createDate: '',
        fromShelvesName: '',
        storageName: '',
        targetShelvesName: ''
      },
      list: [], // 外层列表数据
      productList: [], // 内层产品列表
      total: 0,
      currentPage: 1,
      pageSize: 30,
      type: '', // 判断新增还是修改，
      multipleSelection: [] // 全选货单选后存取的数据列表
    }
  },
  methods: {
    onInput (e) {
      // 非0开头的正整数
      e.target.value = e.target.value.replace(/^(0+)|[^\d]+/g, '')
    },
    // 初始化列表数据
    onInitialize (row, type) {
      this.disableDialog = false // 外层dialog
      this.innerVisible = false // 内层dialog
      this.stockSelect = [] // 仓库列表
      this.shelfSelect = [] // 货架列表
      this.holdShelfSelect = [] // 调入货架
      this.queryParams = {
        // 查询货架信息传参数
        id: '', // 仓库id
        ssId: '', // 调出货架id
        sssId: '', // 调入货架id
        createDate: '',
        fromShelvesName: '',
        storageName: '',
        targetShelvesName: ''
      }
      this.list = [] // 外层列表数据
      this.productList = [] // 内层产品列表
      this.disableDialog = true
      this.type = type
      if (this.type === 1) {
        // 查看详情 - 仓库编码 allocationNumber
        this.queryParams = row
        queryShelvesProducts(row.allocationNumber)
          .then(res => {
            if (res.data.code === 200) {
              this.list = res.data.obj.storageAllocationStockVoList
              this.loadingTable = false
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.queryParams = {}
        this.gethouseList()
      }
    },
    // 获取仓库信息
    async gethouseList () {
      this.stockSelect = await this.$houseInformation()
      if (this.queryParams.id) {
        this.onSelect(this.queryParams.id)
      }
    },
    // 详细资料 -> 获取货架
    onSelect (id) {
      // 循环仓库数组，通过仓库id拿到对应的仓库名称并赋值给storageName
      this.stockSelect.forEach(item => {
        if (item.id === id) {
          this.queryParams.storageName = item.storageName
        }
      })
      this.shelfSelect = []
      queryBySbIdSsId(id)
        .then(res => {
          if (res.data.code === 200) {
            this.shelfSelect = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 调入货架
    chagefromShelves (id) {
      querySsIdBySbIdAndSsId(this.queryParams.id, id).then(
        res => {
          if (res.data.code === 200) {
            this.holdShelfSelect = res.data.obj
          }
        }
      )
    },
    exportWarehousing () {
      const queryParams = {}
      queryParams.allocationNumber = this.queryParams.allocationNumber
      queryParams.allocationUrl = this.$store.state.storeManagementList

      addAllocationCoeDerive(queryParams)
        .then((res) => {
          downLoadFileBlob(this, res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 打开内层dialog
    onAddProduct () {
      if (this.queryParams.id === undefined || this.queryParams.ssId === undefined) {
        this.$message.error('请先选择仓库和调出货架')
      } else {
        this.innerVisible = true
        if (this.list.length === 0) {
          getStockProduct(this.queryParams.id, this.queryParams.ssId)
            .then(res => {
              if (res.data.code === 200) {
                this.productList = res.data.obj
                this.loadingTable = false
                this.disableDialog = false
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          return this.list
        }
      }
    },
    // 全选，单选取得的数据
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 确认选择产品
    onSureProduct () {
      // 外层表格数据
      if (this.multipleSelection.some(ele => ele.number === undefined)) {
        this.$message.error('调拨数量不能为空')
      } else {
        const concatList = this.multipleSelection
        this.disableDialog = true
        this.storageNameDisable = true
        // 内存dialog关闭
        this.innerVisible = false
        this.list = concatList
      }
    },
    // 取消选择的产品
    cancleSelect () {
      this.multipleSelection = []
      // this.productList = []
      this.innerVisible = false
      this.disableDialog = true
    },
    // 删除当前行所选的产品信息
    toDelete (row) {
      // 根据产品proId查询productList里对应的数据
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].proId === row.proId) {
          this.list.splice(i, 1)
          this.productList.splice(i, 1)
        }
      }
      return this.list
    },
    onSubmit () {
      if (this.queryParams.shelvesName === undefined) {
        this.$message.error('请选择调入货架')
      } else if (this.list.length === 0) {
        this.$message.error('请先添加产品')
      } else {
        this.shelfSelect.forEach(item => {
          if (item.ssId === this.queryParams.ssId) {
            this.queryParams.fromShelvesName = item.shelvesName
          }
        })
        this.holdShelfSelect.forEach(item => {
          if (item.shelvesName === this.queryParams.shelvesName) {
            this.queryParams.sssId = item.id
            this.queryParams.targetShelvesName = item.shelvesName
          }
        })
        this.list.forEach(ele => {
          ele.count = ele.number
        })
        if (this.list.some(ele => ele.number === undefined)) {
          this.$message.error('调拨数量不能为空')
          return
        }
        const params = {
          sbId: this.queryParams.id,
          fromShelvesName: this.queryParams.fromShelvesName,
          fromSsId: this.queryParams.ssId,
          targetSsId: this.queryParams.sssId,
          targetShelvesName: this.queryParams.targetShelvesName,
          storageName: this.queryParams.storageName,
          storageAllocationListVoList: this.list
        }
        addAllocation(params)
          .then(res => {
            if (res.data.code === 200) {
              console.log(this.list)
              this.$message.success('保存成功')
              this.loadingTable = false
              this.queryParams = {}
              this.list = []
              this.disableDialog = false
              this.storageNameDisable = false
              this.$emit('addAllocation')// 传值
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 取消
    cancle () {
      this.disableDialog = false
      this.storageNameDisable = false
      this.list = []
      this.productList = []
    },
    //  对话框关闭事件
    onClose () {
      this.storageNameDisable = false
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip {
  margin: 10px 0 40px 30px;
}
.add_product_btn {
  width: 100%;
  height: 32px;
  border: 1px dashed #d2d6e0;
  color: #276cff;
  text-align: center;
  line-height: 32px;
  margin-top: 20px;
}
.tableHeight {
  max-height: 589px;
  min-height: 384px;
}
</style>
